import { ENVIRONMENTS, forgeCDNUrlByEnv } from "@cede/utils";
import { clientConfig } from "@/lib/config/client-config";

/**
 * Resolves a CMS file S3 key (e.g. "cms-media/uuid-file.png") to a full CDN URL.
 * Same pattern as forgeTokenURL but for CMS media files.
 */
export const forgeCmsMediaUrl = (key: string | null | undefined): string | null => {
  if (!key) return null;
  return forgeCDNUrlByEnv(key, clientConfig.nodeEnv as ENVIRONMENTS);
};
